import { motion } from 'motion/react';
import { type ReactNode } from 'react';

import { Empty } from '@/components/ui/EmptyState';

const CARDS = [
  { y: 22, from: { x: -90, y: -24, rotate: -14 }, fillOpacity: 0.04 },
  { y: 42, from: { x: 90, y: -24, rotate: 14 }, fillOpacity: 0.07 },
  { y: 62, from: { x: 0, y: 60, rotate: 0 }, fillOpacity: 0.1 },
];

const ProjectEmptyStateAnimation = () => (
  <svg
    viewBox="0 0 180 100"
    className="w-40 h-[5.625rem] text-foreground-muted overflow-visible"
    aria-hidden
  >
    {CARDS.map((card, i) => (
      <motion.g
        key={i}
        initial={{
          x: card.from.x,
          y: card.from.y,
          rotate: card.from.rotate,
          opacity: 0,
        }}
        animate={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
        transition={{
          duration: 0.9,
          delay: 0.1 + i * 0.16,
          ease: [0.22, 1, 0.36, 1],
        }}
        style={{ transformBox: 'fill-box', transformOrigin: 'center' }}
      >
        <rect
          x={27}
          y={card.y}
          width={125}
          height={14}
          rx={3}
          fill="currentColor"
          fillOpacity={card.fillOpacity}
          stroke="currentColor"
          strokeOpacity={0.15}
          strokeWidth={0.75}
        />
      </motion.g>
    ))}
  </svg>
);

export const ProjectEmptyState = ({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) => (
  <Empty.Root>
    <Empty.Media>
      <ProjectEmptyStateAnimation />
    </Empty.Media>
    <Empty.Header>
      <Empty.Title>{title}</Empty.Title>
      <Empty.Description>{description}</Empty.Description>
    </Empty.Header>
    {action && <Empty.Actions>{action}</Empty.Actions>}
  </Empty.Root>
);
